import FilterActionsEnums from './FilterActionsEnums';

const defaultState = {
    selectedClient: null,
    selectedBu: null,
    selectedShop: null,
    location: null,
    startDate: null,
    endDate: null,
    startSettDate: null,
    endSettDate: null,
    selectedPaymentType: null,
    selectedActivity: null,
    isOpenReportingFilter: true,
};

function FilterReducer(state = defaultState, action) {
    switch (action.type) {
        case FilterActionsEnums.SET_CLIENT:
            return {
                ...state,
                selectedClient: !action.selectedClient || action.selectedClient.length === 0 ? null :
                    Array.isArray(action.selectedClient) ? action.selectedClient.reduce(function(s, a){
                        s.push({name: a});
                        return s;
                    }, []) : [action.selectedClient]
            };
        case FilterActionsEnums.SET_LOCATION:
            return {
                ...state,
                location: !action.location || action.location.length === 0 ? null :
                    Array.isArray(action.location) ? action.location : [action.location]
            };
        case FilterActionsEnums.SET_BU:
            return {
                ...state,
                selectedBu: !action.selectedBu || action.selectedBu.length === 0 ? null :
                    Array.isArray(action.selectedBu) ? action.selectedBu.reduce(function(s, a){
                        s.push({name: a});
                        return s;
                    }, []) : [action.selectedBu]
            };
        case FilterActionsEnums.SET_SHOP:
            return {
                ...state,
                selectedShop: !action.selectedShop || action.selectedShop.length === 0 ? null :
                    Array.isArray(action.selectedShop) ? action.selectedShop.reduce(function(s, a){
                        s.push({name: a});
                        return s;
                    }, []) : [action.selectedShop]
            };
        case FilterActionsEnums.SET_START_DATE:
            return {
                ...state,
                startDate: action.startDate,
            };
        case FilterActionsEnums.SET_END_DATE:
            return {
                ...state,
                endDate: action.endDate,
            };
        case FilterActionsEnums.SET_START_SETT_DATE:
            return {
                ...state,
                startSettDate: action.startSettDate,
            };
        case FilterActionsEnums.SET_END_SETT_DATE:
            return {
                ...state,
                endSettDate: action.endSettDate,
            };
        case FilterActionsEnums.SET_PAYMENT_TYPE:
            return {
                ...state,
                selectedPaymentType: action.paymentType,
            };
        case FilterActionsEnums.SET_ACTIVITY:
            return {
                ...state,
                selectedActivity: action.activity,
            };
        case FilterActionsEnums.SET_REPORTING_FILTER_OPEN:
            return {
                ...state,
                isOpenReportingFilter: action.isOpenReportingFilter,
            };
        default:
            return state;
    }
}

export default FilterReducer;



// WEBPACK FOOTER //
// ./src/store/filters/FilterReducer.js